import Loading from "../../../components/Common/Loading";

import {useGetArchivedStateV2DSQuery, useRestoreArchivedStateV2DSMutation} from "../../../core/api/ds-archive-api";
import {useParams} from "react-router-dom";
import Archive from "../../Archive/Archive";
import {useSelector} from "react-redux";
import {Alert} from "@mui/material";

function ArchiveDS(props) {
    const {deviceId, action, tab: tabParam, subtab: subTabParam, game} = useParams()

    const CommonData = useSelector((state) => state.data.CommonData)
    console.log("CommonData")
    console.log(CommonData)

    const stateId = CommonData.deviceId;
    const vendorId = CommonData.stateId;

    const mainId = vendorId === undefined || vendorId === '' ? stateId : vendorId

    const [restoreState, restoreStateResponse] = useRestoreArchivedStateV2DSMutation();
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch,
        isFetching
    } = useGetArchivedStateV2DSQuery(mainId);

    return (
        <>
            <h2>Archives for {mainId}</h2>
            {mainId=='' && <Alert severity={"info"}>Input vendor id</Alert> }
            {mainId!='' && <Loading
                isLoading={isLoading}
                isError={isError}
                error={error}
                isSuccess={isSuccess}
                isFetching={isFetching}
            >
                <Archive archiveListReady={isSuccess}
                         archiveList={data}
                         restoreState={restoreState}
                         restoreStateResponse={restoreStateResponse}
                         stateId={stateId}
                         vendorId={vendorId}
                         refetch={refetch}
                         game={props.game}
                />
            </Loading>}

        </>
    );

}

export default ArchiveDS;
